var $6b39616688a51692$exports = {};
$6b39616688a51692$exports = {
  "longPressMessage": "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
export { $6b39616688a51692$exports as default };